import { TRANSFER_REGISTRATION_FORM } from 'src/modules/transferRegistration/constants';
import { modalStore } from 'src/modules/transferRegistration/stores';

import { errorsStore } from 'stores';

export const clearForm = () => {
  errorsStore.clear(TRANSFER_REGISTRATION_FORM);
  modalStore.clear();
};
